import { Component } from "react";

// Keeps one broken component from blanking the whole site.
export default class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-bv-base p-8 text-center">
          <div>
            <p className="font-display text-4xl uppercase text-bv-ink">
              Lost in the verse.
            </p>
            <button type="button" className="btn-primary mt-8" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
